import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { STATUS_LABELS, WO_STATUSES } from '@wo/shared';
import { api, qs } from '../lib/api';
import { date } from '../lib/format';
import type { WorkOrderRow } from '../lib/types';
import { Input, Loading, PageHeader, Select, StatusBadge, Table } from '../components/ui';

export function WorkOrderTable({ rows }: { rows: WorkOrderRow[] }) {
  return (
    <Table head={['#', 'Status', 'Customer', 'Machine', 'Job type', 'Assigned', 'Opened']} empty={rows.length === 0}>
      {rows.map((w) => (
        <tr key={w.id} className="hover:bg-slate-50">
          <td className="px-3 py-2 font-bold"><Link className="text-blue-800 hover:underline" to={`/work-orders/${w.id}`}>{w.number}</Link></td>
          <td className="px-3 py-2"><StatusBadge status={w.status} /></td>
          <td className="px-3 py-2">{w.customer?.name}</td>
          <td className="px-3 py-2">{w.machine && `${w.machine.make} ${w.machine.model} · ${w.machine.serialNumber}`}</td>
          <td className="px-3 py-2">{w.jobType}</td>
          <td className="px-3 py-2">{w.assignedUser?.name ?? '—'}</td>
          <td className="px-3 py-2">{date(w.openedAt)}</td>
        </tr>
      ))}
    </Table>
  );
}

export function WorkOrdersPage() {
  const [q, setQ] = useState('');
  const [status, setStatus] = useState('ACTIVE');
  const rows = useQuery({ queryKey: ['work-orders', q, status], queryFn: () => api.get<WorkOrderRow[]>(`/api/work-orders${qs({ q, status, limit: 300 })}`) });
  return (
    <>
      <PageHeader title="Work Orders">
        <Input placeholder="Number, customer, serial, problem…" value={q} onChange={(e) => setQ(e.target.value)} className="w-72" />
        <Select value={status} onChange={(e) => setStatus(e.target.value)} className="w-48">
          <option value="ACTIVE">All active</option>
          <option value="">All</option>
          {WO_STATUSES.map((s) => <option key={s} value={s}>{STATUS_LABELS[s]}</option>)}
        </Select>
      </PageHeader>
      <div className="rounded-lg border border-slate-200 bg-white">{rows.isLoading ? <Loading /> : <WorkOrderTable rows={rows.data ?? []} />}</div>
    </>
  );
}
